export const rettyPlanSitesForFilter = ['Google マップ', 'Trip Advisor', 'Retty'] as const
